/**
 * Auth helpers for the Emergent-managed Google OAuth flow.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authApi = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export async function getMe() {
    const res = await authApi.get("/auth/me");
    return res.data;
}

export async function exchangeSession(sessionId) {
    const res = await authApi.post("/auth/google-session", { session_id: sessionId });
    return res.data;
}

export async function logout() {
    try {
        await authApi.post("/auth/logout");
    } catch (_e) {
        // ignore
    }
}

export function startGoogleLogin(returnTo = "/admin") {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + returnTo;
    window.location.href =
        "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
}
